import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  min-height: 56px;
  display: flex;
  align-items: center;
  position: fixed;
  background-color: var(--color-background-neutral-default);
  padding: 0 24px;

  top: 0;
  left: 0;
  z-index: var(--zIndexMaximum);
`

export const CleanIcon = styled.div`
  width: 24px;
  height: 24px;
  background-color: transparent;
`
export const IconButton = styled.button`
  margin-top: 6px;
  background: transparent;
  border: 0;
`
